(() => {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	if (reduceMotion.matches) {
		return;
	}

	const headings = document.querySelectorAll('.has-title-big-font-size');
	if (!window.gsap || !window.ScrollTrigger) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const waitForFonts = () => {
		if (!document.fonts || typeof document.fonts.ready?.then !== 'function') {
			return Promise.resolve();
		}

		return document.fonts.ready.catch(() => undefined);
	};

	const animateHeading = (element) => {
		if (element.__gsapRevealDone) {
			return;
		}
		element.__gsapRevealDone = true;

		const hasUnderline = element.classList.contains('is-style-gardp-underline');
		const hasOverline = element.classList.contains('is-style-gardp-overline');
		const noLineAnimation = element.classList.contains('no-line-animation');

		if (window.SplitText && !noLineAnimation) {
			const split = new SplitText(element, {
				type: 'lines,words',
				linesClass: 'gsap-line'
			});

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: element,
					start: 'top 75%',
					once: true
				}
			});

			tl.from(split.words, {
				yPercent: 100,
				opacity: 0,
				duration: 0.8,
				ease: 'power3.out',
				stagger: 0.03
			});

			if (hasUnderline || hasOverline) {
				tl.to(element, {
					'--underline-scaleX': 1,
					'--underline-scale': 1,
					duration: 0.6,
					ease: 'power2.out',
					onStart: () => {
						gsap.to(element, {
							'--pseudo-scaleX': 1,
							duration: 0.6,
							ease: 'power2.out'
						});
						gsap.set(element, {
							'--after-scaleX': 1
						});
						element.style.setProperty('--after-scaleX', '1');
						const afterEl = window.getComputedStyle(element, '::after');
						gsap.fromTo(element, 
							{ '--line-width': 0 },
							{ '--line-width': 139, duration: 0.6, ease: 'power2.out' }
						);
					}
				}, '-=0.2');
			}
		} else {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: element,
					start: 'top 75%',
					once: true
				}
			});

			tl.from(element, {
				y: 24,
				opacity: 0,
				duration: 0.8,
				ease: 'power3.out'
			});

			if (hasUnderline) {
				tl.to(element, {
					'--line-width': 139,
					duration: 0.6,
					ease: 'power2.out'
				}, '-=0.2');
			}
		}

		if (hasUnderline) {
			gsap.fromTo(element,
				{ '--underline-scaleX': 0 },
				{
					'--underline-scaleX': 1,
					duration: 0.6,
					ease: 'power2.out',
					delay: 0.6,
					scrollTrigger: {
						trigger: element,
						start: 'top 75%',
						once: true
					}
				}
			);
		}
	};

	if (headings.length) {
		waitForFonts().then(() => {
			headings.forEach((heading) => animateHeading(heading));
			ScrollTrigger.refresh();
		});
	}

	// Mission background parallax
	const missionMediaQuery = window.matchMedia('(min-width: 768px)');
	if (missionMediaQuery.matches) {
		const missionBgImages = document.querySelectorAll('.gardp-mission-bg-image');
		missionBgImages.forEach((bgImage) => {
			const sectionTrigger = bgImage.closest('.is-style-gardp-mission-section') || bgImage;
			gsap.fromTo(bgImage,
				{ yPercent: 0 },
				{
					yPercent: -16,
					ease: 'none',
					scrollTrigger: {
						trigger: sectionTrigger,
						start: 'top 70%',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true
					}
				}
			);
		});
	}

	// Stagger-in columns
	// const staggerContainers = document.querySelectorAll('.stagger-in');
	// staggerContainers.forEach((container) => {
	// 	if (container.__gsapStaggerInit) {
	// 		return;
	// 	}
	// 	container.__gsapStaggerInit = true;

	// 	const staggerItems = Array.from(container.children).filter((child) => {
	// 		return child.classList.contains('wp-block-column') || child.classList.contains('wp-block-group');
	// 	});

	// 	if (!staggerItems.length) {
	// 		// Fallback: animate direct children when block wrapper classes differ.
	// 		staggerItems.push(...Array.from(container.children));
	// 	}

	// 	if (!staggerItems.length) {
	// 		return;
	// 	}

	// 	gsap.to(staggerItems, {
	// 		opacity: 1,
	// 		y: 0,
	// 		scale: 1,
	// 		duration: 0.8,
	// 		ease: 'easeInOut',
	// 		stagger: { each: 0.15, from: 'start' },
	// 		scrollTrigger: {
	// 			trigger: container,
	// 			start: 'top 70%'
	// 		}
	// 	});
	// });

	// Background zoom animation
	const bgZoomCover = document.querySelectorAll('.background-zoom');
	bgZoomCover.forEach((frame) => {
		const coverImage = frame.querySelector('img.wp-block-cover__image-background');
		if (coverImage) {
			gsap.set(coverImage, { transformOrigin: 'center center', willChange: 'transform' });
			gsap.fromTo(coverImage,
				{ scale: 1 },
				{
					scale: 1.3,
					ease: 'none',
					scrollTrigger: {
						trigger: frame,
						start: 'top 80%',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true
					}
				}
			);
			return;
		}
	});

	// Refresh after assets load to ensure parallax positions recalc
	window.addEventListener('load', () => ScrollTrigger.refresh());
})();
